var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aibuy-explorer"},[_c('button',{staticClass:"aibuy-explorer__reload btn btn-sm btn-light",on:{"click":_vm.reloadAlibuy}},[_c('i',{staticClass:"ri-refresh-line mr-1"}),_vm._v("새로고침 ")]),_c('iframe',{ref:"alibuyFrame",staticClass:"aibuy-explorer__frame",attrs:{"src":_vm.alibuyUrl,"allow":"clipboard-write"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }